"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EUndergroundType = exports.ETransportType = void 0;
let ETransportType = exports.ETransportType = /*#__PURE__*/function (ETransportType) {
  ETransportType["Transport"] = "transport";
  ETransportType["Walk"] = "walk";
  return ETransportType;
}({});
let EUndergroundType = exports.EUndergroundType = /*#__PURE__*/function (EUndergroundType) {
  EUndergroundType["Ekb"] = "ekb";
  EUndergroundType["Kzn"] = "kzn";
  EUndergroundType["Mow"] = "mow";
  EUndergroundType["Nn"] = "nn";
  EUndergroundType["Nsk"] = "nsk";
  EUndergroundType["Smr"] = "smr";
  EUndergroundType["Spb"] = "spb";
  return EUndergroundType;
}({});